import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@material-ui/core/SvgIcon';

const TeacherBoard = ({ className, ...props }) => (
  <SvgIcon
    width="16"
    height="16"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classnames({
      icon: true,
      [className]: !!className
    })}
    {...props}
  >
    <g id="Icons/FA/Solid/chalkboard-teacher">
      <path
        id="Vector"
        d="M5.20003 10.4001C5.14028 10.4001 5.08053 10.4088 5.02353 10.4273C4.69953 10.5326 4.35878 10.6001 4.00003 10.6001C3.64128 10.6001 3.30053 10.5326 2.97628 10.4273C2.91928 10.4088 2.85978 10.4001 2.80003 10.4001C1.24854 10.4001 -0.00820959 11.6621 4.03869e-05 13.2156C0.00354038 13.8721 0.543289 14.4001 1.20004 14.4001H6.80002C7.45677 14.4001 7.99652 13.8721 8.00002 13.2156C8.00827 11.6621 6.75152 10.4001 5.20003 10.4001ZM4.00003 9.60008C5.32553 9.60008 6.40002 8.52558 6.40002 7.20008C6.40002 5.87459 5.32553 4.80009 4.00003 4.80009C2.67453 4.80009 1.60004 5.87459 1.60004 7.20008C1.60004 8.52558 2.67453 9.60008 4.00003 9.60008ZM14.8 1.6001H5.20003C4.53828 1.6001 4.00003 2.15635 4.00003 2.83984V4.00009C4.58553 4.00009 5.12753 4.16959 5.60003 4.44509V3.20009H14.4V10.4001H12.8V8.80008H9.60002V10.4001H7.69402C8.17152 10.8173 8.52202 11.3683 8.68627 12.0001H14.8C15.4618 12.0001 16 11.4438 16 10.7603V2.83984C16 2.15635 15.4618 1.6001 14.8 1.6001Z"
        fill="#FC2472"
      />
    </g>
  </SvgIcon>
);

export default TeacherBoard;
